import GoogleIcon from "../../../icons/google";
import LoginButton from "../button";
import { LoginButtonProps } from "../types";
import useWebOAuthLogin from "../useWebOAuthLogin";

const Google = (props: LoginButtonProps) => {
  const { label = "Iniciar sesión con Google" } = props;
  const signIn = useWebOAuthLogin("google", {
    endpoint: "https://accounts.google.com/o/oauth2/v2/auth",
    clientId:
      "663937048141-j9mjotcjhl3712o9tilnu7sul1hmlgpn.apps.googleusercontent.com",
    redirectPath: "/auth/google/",
    scope: "openid email profile",
    next: props.next,
    beforeSignIn: props.beforeSignIn,
  });

  return (
    <LoginButton
      label={label}
      Icon={GoogleIcon}
      loading={false}
      onPress={signIn}
      className={`bg-white data-[active=true]:bg-neutral-200 gap-2 ${props.className ?? ""}`}
      textClassName="text-[#757575] stroke-transparent"
      variant="outline"
      size={props.size}
      rounded={props.rounded}
    />
  );
};

export default Google;
